import React from 'react';

import {getCaptchaToken, Recaptcha} from '../ui/recaptcha';

export default function withRecaptcha(WrappedComponent) {
  return props => {
    const captchaProps = {
      get: getCaptchaToken('login'),
      render: () => <Recaptcha />
    };

    return (
      <WrappedComponent
        captchaProps={captchaProps}
        {...props}
      />
    );
  };
}
